import * as Sentry from '@sentry/vue';

export const useLocalstorage = () => {
  const STORAGE_KEY = {
    USER_ID: 'nhk-user-id',
    USER_NAME: 'nhk-user-name',
    // アンケート回答済みフラグ
    ANSWERED_QUESTIONNAIRE: 'nhk-answered-questionnaire',
    // score
    SCORE_NORMAL: 'nhk-score-normal',
    // 過去の最高得点
    OLD_BEST_SCORE_NORMAL: 'nhk-old-best-score-normal',
    // 最高得点だったか
    IS_BEST_SCORE_NORMAL: 'nhk-is-best-score-normal',
    // 受験回数に応じたキャラクターのレベル
    CHARACTER_LEVEL: 'nhk-character-level',
  } as const;
  type StorageKey = (typeof STORAGE_KEY)[keyof typeof STORAGE_KEY];

  const getStorage = (key: StorageKey) => {
    Sentry.addBreadcrumb({
      category: 'storage',
      message: 'ローカルストレージ keyが取得できているか ' + key,
      level: 'debug',
      data: {
        key,
      },
    });

    const data = localStorage.getItem(key);

    Sentry.addBreadcrumb({
      category: 'storage',
      message: 'ローカルストレージからデータ取得できているか ' + data,
      level: 'debug',
      data: {
        data,
      },
    });
    if (!data) return;
    return JSON.parse(data);
  };

  const setStorage = (key: StorageKey, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  return {
    STORAGE_KEY,
    getStorage,
    setStorage,
  };
};
